import { Breakpoints } from '@pb/utils'

import { NotificationType, Notification, Styleboard } from '../../types'
import {
  copyStyleboardLinkNotification,
  deleteStyleboardNotificationFail,
  followStyleboardFailed,
  putProfileFailNotification,
  putProfileNotification,
  putStyleboardFailedNotification,
  putStyleboardNotification,
  addImageToStyleboardNotificationFailed,
  deleteItemFromStyleboardFailed,
  fetchFollowStyleboardsFail,
  fetchStyleboardsFail,
  changeBackgroundImageFailed,
} from './constants'

export const getCorrectNotification = (type: NotificationType): Notification => {
  const notifications = {
    [NotificationType.STYELBOARD_DELETED_FAILED]: deleteStyleboardNotificationFail,
    [NotificationType.COPY_STYLEBOARD_LINK]: copyStyleboardLinkNotification,
    [NotificationType.FOLLOW_STYLEBOARD_FAILED]: followStyleboardFailed,
    [NotificationType.PUT_PROFILE_SUCCEEDED]: putProfileNotification,
    [NotificationType.PUT_PROFILE_FAILED]: putProfileFailNotification,
    [NotificationType.PUT_STYLEBOARD_FAILED]: putStyleboardFailedNotification,
    [NotificationType.PUT_STYLEBOARD_SUCCEDED]: putStyleboardNotification,
    [NotificationType.ADD_IMAGE_STYLEBOARD_FAILED]: addImageToStyleboardNotificationFailed,
    [NotificationType.STYLEBOARD_ITEM_DELETE_FAILED]: deleteItemFromStyleboardFailed,
    [NotificationType.FETCH_STYLEBOARDS_FAILED]: fetchStyleboardsFail,
    [NotificationType.FETCH_FOLLOW_STYLEBOARDS_FAILED]: fetchFollowStyleboardsFail,
    [NotificationType.CHANGE_BACKGROUND_IMAGE_FAILED]: changeBackgroundImageFailed,
  }
  return notifications[type]
}

/**
 *
 * @param link the next link that includes page and size for styleboards endpoint
 */
export const getCorrectUrlForPagination = (link?: string): string => {
  return link?.replace(/(https:|)(^|\/\/)(.*?\/)/g, `${window.location.origin}/`) || ''
}

/**
 *
 * @param imageUrl The image url we want to verify
 * @returns  If the url is valid or not
 */

export const isImageUrlValid = (imgeUrl: string = ''): boolean =>
  new RegExp(/^https?:\/\/.+\/.+$/).test(imgeUrl)

/**
 *
 * @param popularStyleboards an array of popular stylebards we want to filter
 * @param followStyleboards user's followed boards
 * @param authorId user's author id
 * @returns Filtered popular styleboards based on author id and followed boards
 */
export function filterPopularStyleboards<T extends Styleboard>(
  popularStyleboards: T[] = [],
  followStyleboards: T[] = [],
  authorId: string = '',
): T[] {
  const followStyleboardIds = followStyleboards.map((item) => item.id)
  return popularStyleboards.filter((popularBoard) => {
    if (authorId) {
      return popularBoard.author.id !== authorId && !followStyleboardIds.includes(popularBoard.id)
    }
    return !followStyleboardIds.includes(popularBoard.id)
  })
}

/**
 *
 * @param items Styleboard items array
 * @param breakPoint Current breakpoint from useBreakpoint hook
 * @returns An array on rows, based on current breakpoint [Dependent on current grid setting in SB detail page]
 */

export const splitItemsIntoRows = (items: Array<any>, breakPoint: string): any[] => {
  const articlePerRows =
    breakPoint === Breakpoints.MEDIUM ||
    breakPoint === Breakpoints.SMALL ||
    breakPoint === Breakpoints.XSMALL
      ? 2
      : 3
  const rows: Array<any> = []

  for (let i = 0; i < items.length; i += articlePerRows) {
    const chunk = items.slice(i, i + articlePerRows)
    rows.push(chunk)
  }

  return rows
}

/**
 *
 * @param items Styleboard items array
 * @param breakPoint Current breakpoint from useBreakpoint hook
 * @param articleId Certain article id for finding its position in the screen
 * @param idIsCode Search the items by code field
 * @returns A string indicating the article's position
 */
export const findArticlePosition = (
  items: Array<any>,
  breakPoint: string,
  articleId: string,
  idIsCode?: boolean,
): string => {
  const itemIds = idIsCode ? items.map((item) => item?.code) : items.map((item) => item?.id)
  const rows = splitItemsIntoRows(itemIds, breakPoint)
  let articleIndexInRow = 0

  rows.forEach((row) => {
    const articleIndex = row.indexOf(articleId)
    if (articleIndex >= 0) articleIndexInRow = articleIndex + 1
  })

  return articleIndexInRow.toString()
}
